"use client";
import BupiLink from "@/components/atoms/link";
import React from "react";

const FooterContactSection = ({ title, description, formLink }: any) => {
  return (
    <div className="bg-bupi-primary w-full xl:container-70 flex md:py-32 flex-col justify-between">
      <div className="flex-grow container mx-auto ">
        <div className="h-full bottom-0 w-full xl:w-[840px] ml-auto py-32 px-4 text-white">
          <div className="w-full xl:w-9/12">
            <div>
            <h2 className="text-l-bold md:text-l-bold text-neutral-900">
              {title}
            </h2>

            <div className="text-m-regular text-neutral-900 mt-16 mb-32">
              <p>{description}</p>
            </div>

            <ul className="relative z-[1] w-full xs:col-span-1 md:col-span-8 xl:col-span-6 inline-flex gap-x-32 xs:flex-col md:flex-row xl:flex-row">
              {formLink.map((data: any, index: number) => (
                <li key={index} className="py-8">
                  <BupiLink
                    label={data?.label}
                    url={data?.href}
                    hasIcon
                    className="py-8"
                    target={data?.target}
                  />
                </li>
              ))}
            </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterContactSection;
